// Libraries
import React from 'react';
import {css} from 'aphrodite/no-important';
// Core
import {randomElementFromArray} from '../core/Utilities';
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';
import ContentData from '../core/ContentData';
import CoreStyles from '../core/Styles';
import {TitleText, HeadingMediumText, BodyText, LabelMediumText, LabelSmallText} from '../core/Type';
import {FixedSpace, FlexibleSpace, HorizontalRule} from '../core/Spacing';
import Glyph from '../core/Glyph';
// Controls
import TabBar from '../controls/TabBar';
// Layouts
import {OneColumnLayout, ThreeColumnLayout, FourColumnLayout} from '../layouts/Grid';
import ToolBar from '../layouts/ToolBar';
// Modules
import UpsellCards from '../modules/UpsellCards';
import SiteBar from '../modules/SiteBar';
import SiteFooter from '../modules/SiteFooter';

export default class LoggedInHomePage extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            page: {
                display: "flex",
                flexDirection: "column-reverse",
            },
            heroModule: {
                width: "100%",
                paddingTop: CoreMetrics.ElementSpacing.XLarge(),
                paddingBottom: CoreMetrics.ElementSpacing.XLarge(),
                backgroundColor: CoreMetrics.Color.Neutral.OffWhite,
            },
            module: {
                width: "100%",
                paddingTop: CoreMetrics.ElementSpacing.XLarge(),
            },
            toolbarContent: {
                display: "flex",
                flexDirection: "row",
                width: CoreMetrics.Grid.FixedWidth,
                height: "100%",
                marginLeft: "auto",
                marginRight: "auto",
            },
        });

        return (
            <div className={css(styles.page)}>
                <SiteFooter />

                <FixedSpace
                    variant={FixedSpace.Variant.Vertical}
                    size={FixedSpace.Size.XLarge}
                />

                <div className={css(styles.module)}>
                    <OneColumnLayout column1={<FeaturedImage />} />
                </div>

                <UpsellCards variant={UpsellCards.Variant.Mission} />

                <div className={css(styles.module)}>
                    <OneColumnLayout
                        column1={
                            <HeadingMediumText>
                                Resume learning
                            </HeadingMediumText>
                        }
                    />

                    <FixedSpace
                        variant={FixedSpace.Variant.Vertical}
                        size={FixedSpace.Size.XLarge}
                    />

                    <FourColumnLayout
                        column1={<UnitCarouselThumbnail />}
                        column2={<UnitCarouselThumbnail />}
                        column3={<UnitCarouselThumbnail />}
                        column4={<UnitCarouselThumbnail />}
                    />
                </div>

                <div className={css(styles.module)}>
                    <OneColumnLayout
                        column1={
                            <HeadingMediumText>
                                My subjects
                            </HeadingMediumText>
                        }
                    />
                    <FixedSpace
                        variant={FixedSpace.Variant.Vertical}
                        size={FixedSpace.Size.XSmall}
                    />
                    <ThreeColumnLayout
                        column1={<MyCourseTile />}
                        column2={<MyCourseTile />}
                        column3={<MyCourseTile />}
                    />
                    <FixedSpace
                        variant={FixedSpace.Variant.Vertical}
                        size={FixedSpace.Size.XLarge}
                    />
                    <OneColumnLayout column1={<HorizontalRule />} />
                </div>

                <ToolBar>
                    <div className={css(styles.toolbarContent)}>
                        <TabBar
                            items={[
                                "Home",
                                "Profile",
                                "Badges",
                                "Progress",
                                "Discussion",
                                "Projects",
                                "Coaches",
                            ]}
                            selectedIndex={0}
                        />
                    </div>
                </ToolBar>

                <div className={css(styles.heroModule)}>
                    <OneColumnLayout
                        column1={<TitleText>Betsy Appleseed</TitleText>}
                    />
                </div>
                <SiteBar />
            </div>
        );
    }
}

class MyCourseTile extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            container: {
                display: "flex",
                flexDirection: "column-reverse",
            },
            toolbar: {
                paddingLeft: 0,
                paddingRight: 0,
            },
        });
        return (
            <div className={css(styles.container)}>
                <MyCourseUnitRow />
                <MyCourseUnitRow />
                <MyCourseUnitRow />
                <MyCourseUnitRow />
                <MyCourseUnitRow />
                <FixedSpace variant={FixedSpace.Variant.Vertical} size={FixedSpace.Size.XSmall} />
                <ToolBar styles={[styles.toolbar, CoreStyles.hairlineStrokeBottom]}>
                    <LabelMediumText>{randomElementFromArray(ContentData.Subjects)}</LabelMediumText>
                    <FlexibleSpace />
                    <LabelSmallText>See all 23</LabelSmallText>
                </ToolBar>
            </div>
        );
    }
}

class MyCourseUnitRow extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            container: {
                display: "flex",
                flexDirection: "row",
                paddingTop: CoreMetrics.ElementPadding.XSmall(),
                paddingBottom: CoreMetrics.ElementPadding.XSmall(),
                alignItems: "center",
            },
        });
        return (
            <div className={css(styles.container)}>
                <Glyph size={Glyph.Size.XLarge} />
                <FixedSpace />
                <BodyText>{randomElementFromArray(ContentData.Units)}</BodyText>
            </div>
        );
    }
}

class UnitCarouselThumbnail extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            container: {
                display: "flex",
                flexDirection: "column",
            },
            thumbnail: {
                width: "100%",
                paddingBottom: "56.25%",
                backgroundColor: CoreMetrics.Color.Debug,
                borderRadius: CoreMetrics.CornerRadius,
            },
        });
        return (
            <div className={css(styles.container)}>
                <div className={css(styles.thumbnail)}></div>
                <FixedSpace variant={FixedSpace.Variant.Vertical} size={FixedSpace.Size.XSmall} />
                <LabelMediumText>{randomElementFromArray(ContentData.Units)}</LabelMediumText>
                <FixedSpace variant={FixedSpace.Variant.Vertical} size={FixedSpace.Size.XXSmall} />
                <LabelSmallText>{randomElementFromArray(ContentData.Subjects)}</LabelSmallText>
            </div>
        );
    }
}

class FeaturedImage extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            container: {
                display: "block",
                position: "relative",
            },
            image: {
                width: "100%",
                paddingBottom: "33.33%",
                backgroundColor: CoreMetrics.Color.Debug,
                borderRadius: CoreMetrics.CornerRadius,
            },
        });
        return (
            <div className={css(styles.container)}>
                <div className={css(styles.image)}></div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/demo/LoggedInHomePage.jsx